<script setup>
    definePageMeta({ layout: 'archives' });
</script>
<template>
    <TemplatesSitesArchives />
</template>
